<template>
    <div class="icon-page manage-wrapper">
        <div class="page-content-wrapper">
            <ShareOutputInfo v-if="teamID && showOperate" :accountInfo="accountInfo" :trend="trend" />
            <div class="coin-page-outer">
                <h6 class="font-sty1 bottom-line clearfix" v-if="showOperate">
                    <span class="fl">收益管理</span>
                    <button class="manage-btn fr" v-if="memberType === 0" @click="showModal(0)">分配</button>
                </h6>

                <LearnCoin
                    :incom="coinBill.amountIn"
                    :distribution="coinBill.amountOut"
                    :remain="coinBill.totalAmount"
                />

                <LearnTable ref="coinTable" :params="customParams" @showModal="showModal" @detailClick="detailClick" :tradeTypes="tradeTypes"/>
            </div>

            <!-- 弹窗操作 -->
            <a-modal class="custom-modal" v-model="visible" :title="modalTitle" width="590px">
                <template slot="footer">
                    <button key="back" class="model-btn-cancel" @click="handleCancel">
                        取消
                    </button>
                    <button v-if="showDistribution" key="submit" class="model-btn-confirm" @click="handleDistribution">
                        分配
                    </button>
                </template>
                <div class="modal-cont">
                    <LearnDistribution
                        v-if="showDistribution"
                        v-model="members"
                        :totalCoin="coinBill.totalAmount / 100"
                        :chosenCoin="chosenCoin"
                    />
                    <LearnDetail v-if="showDetail" :listDetail="listDetail" :listItem="listItem" />
                </div>
            </a-modal>
        </div>
    </div>
</template>
<script>
    import { teamInfo, teamTrend } from '@/store/api/share/creation';
    import { totalCoinDetail, teamDistributeCoin, memberInfo } from '@/store/api/share/team';
    import LearnCoin from './learncoin-calc.vue';
    import LearnTable from './learncoin-table.vue';
    import LearnDetail from './learncoin-detail.vue';
    import LearnDistribution from './learncoin-distribution.vue';
    import ShareOutputInfo from '../share-output-info.vue';
    import { clac } from '../../../../config/math';

    export default {
        props: {
            customParams: {
                type: Object,
                default: () => ({}),
            },
            showOperate: {
                type: Boolean,
                default: true,
            },
            tradeTypes: {
                type: Array,
                default: () => ([
                    { id: 0, text: '全部' },
                    { id: 1, text: '分配' },
                    { id: 3, text: '订阅' },
                    { id: 4, text: '打赏' },
                ]),
            }
        },
        data: () => ({
            coinBill: {
                amountIn: 0,
                amountOut: 0,
                totalAmount: 0,
            },
            chosenCoin: 0,
            members: [], // 所有成员
            incom: 1000, // 总收入
            distribution: 1000, // 总分配
            remain: 1000, // 余额
            visible: false,
            modalType: 0,
            listDetail: {}, // 列表项详情
            teamID: '',
            accountInfo: {},
            trend: {},
            memberType: '',
            listItem: {},
        }),
        watch: {
            visible() {
                this.members = this.members.map((member) => {
                    member.selected = false;
                    member.coinNum = '';
                    return member;
                });
            },
        },
        created() {
            this.getQuery();
            if (this.teamID) {
                this.getTeamInfo();
                this.getTrend();
                this.getTotalCoinDetail();
            }
            // 熊望调用该组件处理
            if (this.customParams && this.customParams.accountType === 2) {
                this.getTotalCoinDetail();
            }
            if (this.showOperate) this.getMembers();
        },
        computed: {
            modalTitle() {
                return ['分配', '明细'][this.modalType] || '';
            },
            showDistribution() {
                return this.modalType === 0 && this.visible === true && this.showOperate;
            },
            showDetail() {
                return this.modalType === 1 && this.visible === true;
            },
            currencyName() {
                return this.$store.state.app.currencyName || '';
            },
        },
        methods: {
            getQuery() {
                this.teamID = this.$safeGet(this.$route && this.$route.query && this.$route.query.teamID) || sessionStorage.getItem('teamID') || '';
                sessionStorage.setItem('teamID', this.teamID);
            },
            showModal(type) {
                this.modalType = type;
                this.visible = true;
            },
            handleCancel() {
                this.visible = false;
            },
            async getTeamInfo() {
                const { data } = await teamInfo({ id: this.teamID });
                this.accountInfo = data;
                this.memberType = data.currentMember.memberType;
            },
            // 统计数据
            async getTrend() {
                const { data } = await teamTrend({ id: this.teamID });
                this.trend = data;
            },
            // 监听点击的表格行->获取操作详细
            detailClick(item) {
                if (item) {
                    this.listItem = item;
                    // this.getCoinDetail({ grantId: this.businessId });
                }
            },
            // 分配确认
            handleDistribution() {
                const seletedMeber = this.members.filter(m => m.selected === true);
                if (seletedMeber.length === 0) {
                    this.$notification.error({ message: '请先选择分配对象！' });
                    return;
                }
                const distributeTotal = seletedMeber.reduce((t, m) => {
                    return clac('+', t, m.coinNum);
                }, 0);
                const hasInvalideCoinNum = seletedMeber.some((m) => {
                    return !m.coinNum;
                });
                if (hasInvalideCoinNum) {
                    this.$notification.error({ message: `请输入分配${this.currencyName}数且数量大于0！` });
                    return;
                }
                if (distributeTotal > clac('/', this.coinBill.totalAmount, 100)) {
                    this.$notification.error({ message: `${this.currencyName}余额不足，请重新分配！` });
                    return;
                }
                const distributeMembers = seletedMeber.map((m) => {
                    return {
                        joinId: m.memberId,
                        tradeAmount: m.coinNum * 100,
                        joinType: 5,
                    };
                });
                const options = JSON.stringify(distributeMembers);
                this.postTeamDistributeCoin({ grantItems: options, enjoyId: this.teamID });
            },
            // 获取所有成员
            async getMembers() {
                const { data } = await memberInfo({ id: this.teamID });
                const initData = data.map((member) => {
                    member.selected = false;
                    member.coinNum = '';
                    return member;
                });
                this.members = initData;
            },
            // 获取总开支详情
            async getTotalCoinDetail() {
                /* 1 机构账号 2 个人账号 3 纷享号账号) */
                const { data } = await totalCoinDetail({ accountCode: this.teamID, accountType: 3, ...this.customParams });
                this.coinBill = data;
            },

            // 纷享号分配学币
            async postTeamDistributeCoin(data) {
                const res = await teamDistributeCoin(data);
                if (res.data) {
                    this.$refs.coinTable.resetOptions();
                    this.$refs.coinTable.getCoinDetailList();
                    this.getTotalCoinDetail();
                    this.visible = false;
                    this.$notification.success({ message: '分配成功！' });
                }
            },
        },
        components: {
            LearnCoin,
            LearnTable,
            LearnDetail,
            LearnDistribution,
            ShareOutputInfo,
        },
    };
</script>
<style lang="less">
@import '../../../../assets/less/share.less';
.icon-page {
    .ant-table-pagination.ant-pagination {
        float: none;
        background: #fff;
        text-align: center;
        & .ant-pagination-item {
            min-width: 32px !important;
            height: 32px !important;
            border-radius: 2px;
        }
    }
    .ant-pagination-item a {
        vertical-align: middle;
        min-width: 32px !important;
        height: 32px !important;
        background-color: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .ant-pagination-item.ant-pagination-item-active a,
    .ant-pagination-item.ant-pagination-item-active a {
        color: #1890ff !important;
        border-radius: 2px;
        background: #fff;
        border: 1px solid #1890ff;
    }

    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
        vertical-align: middle;
        margin-top: 2px;
        min-width: 32px !important;
        height: 32px !important;
        border: 1px solid rgba(0, 0, 0, 0.15) !important;
        display: inline-block !important;
        border-radius: 2px;
    }
    .ant-pagination-options {
        margin-top: 4px;
    }
    .coin-page-outer {
        background: #fff;
        padding: 20px;
        border-radius: 6px;
    }
    .dropdown-no-icon .ant-select-arrow .anticon.anticon-down svg,
    .ant-select-selection .ant-select-arrow .anticon.anticon-up svg,
    .ant-select-selection .ant-select-arrow .anticon.anticon-down svg,
    .ant-pagination-item-link .anticon-right svg,
    .ant-pagination-item-link .anticon-left svg {
        display: block !important;
    }
    .anticon-down::before {
        display: none !important;
    }
    .anticon-right::before {
        display: none !important;
    }
    .anticon-left::before {
        display: none !important;
    }
}
</style>
